import React, { useState, useRef, useEffect } from 'react';

const NotificationModal = ({ 
  isOpen, 
  onClose, 
  onSend, 
  selectedUsers, 
  sending = false 
}) => {
  const [message, setMessage] = useState('');
  const [status, setStatus] = useState('');
  const textareaRef = useRef(null);
  
  // Focus the textarea when the modal opens
  useEffect(() => {
    if (isOpen && textareaRef.current) {
      setTimeout(() => {
        textareaRef.current.focus();
      }, 100);
    }
  }, [isOpen]);
  
  // Reset state when modal closes
  useEffect(() => {
    if (!isOpen) {
      setMessage('');
      setStatus('');
    }
  }, [isOpen]);
  
  if (!isOpen) return null;
  
  const handleMessageChange = (e) => {
    setMessage(e.target.value);
  };
  
  const handleSend = async () => {
    if (!message.trim()) {
      setStatus('Please enter a notification message');
      return;
    }
    
    setStatus('');
    
    try {
      const result = await onSend(message);
      setStatus(result.message || 'Notification sent successfully');
      
      if (result.success && result.details?.failed === 0) {
        setTimeout(() => {
          onClose();
        }, 1500);
      }
    } catch (err) {
      setStatus(`Error: ${err.message}`);
    }
  };
  
  const selectedUserCount = selectedUsers.length;
  
  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <div className="modal-header">
          <h3>Send Push Notification</h3>
          <button className="close-button" onClick={onClose}>×</button>
        </div>
        <div className="modal-body">
          <p>
            Sending notification to <strong>{selectedUserCount}</strong> selected 
            user{selectedUserCount !== 1 ? 's' : ''}
          </p>
          <textarea
            ref={textareaRef}
            placeholder="Enter notification message..."
            value={message}
            onChange={handleMessageChange}
            className="notification-message"
            disabled={sending}
          />
          {status && (
            <div className={status.includes('Error') ? "error-message" : "success-message"}>
              {status}
            </div>
          )}
        </div>
        <div className="modal-footer">
          <button 
            onClick={onClose}
            className="cancel-button"
            disabled={sending}
          >
            Cancel
          </button>
          <button 
            onClick={handleSend}
            className="send-notification-button"
            disabled={sending}
          >
            {sending ? 'Sending...' : 'Send Notification'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default NotificationModal;